<template>
    <div id="ProjBidViewNewProcurementMethod">
        <eb-panel>
            <eb-panel-header class="panel-header" slot="header">
                <span slot="title">1 采购方式</span>
            </eb-panel-header>
            <div slot="body">
                <div class="panel-body-row">
                    <div class="panel-body-row-left">采购类型</div>
                    <div class="panel-body-row-right">
                        {{project.projectType| projectType}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">开始时间</div>
                    <div class="panel-body-row-right">
                        {{project.startTime | startTime}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">截标时间</div>
                    <div class="panel-body-row-right">
                        {{project.endTime | dateFormatYMDH}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">开标形式</div>
                    <div class="panel-body-row-right">
                        {{project.projectStyle | projectStyle}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">开标地点</div>
                    <div class="panel-body-row-right" v-if="project.projectStyle=='1'">
                        {{project.bidProjectArea}}
                    </div>
                    <div class="panel-body-row-right" v-if="project.projectStyle=='2'">
                        -
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">开标时间</div>
                    <div class="panel-body-row-right">
                        {{project.bidProjectOpenTime | dateFormatYMDHm}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">中标公示</div>
                    <div class="panel-body-row-right">
                        {{project.resultPublic | resultPublic}}
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">中标公示</div>
                    <div class="panel-body-row-right" v-if="project.resultPublic=='3'">
                        {{project.durationDays }}
                        <span>天</span>
                    </div>
                    <div class="panel-body-row-right" v-if="project.resultPublic!='3'">
                        -
                    </div>
                </div>
                <div class="panel-body-row">
                    <div class="panel-body-row-left">规则模板</div>
                    <div class="panel-body-row-right">
                        {{project.templateName}}
                    </div>
                </div>
            </div>
        </eb-panel>
    </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import moment from 'moment';
export default {
  name: 'ProjBidViewNewProcurementMethod',
  props: {
    project: {
      require: true
    }
  },
  components: {
    ebPanel,
    ebPanelHeader
  },
  filters: {
    startTime: time => {
      if (time === 32503651200000) {
        return '发布时即开始';
      } else {
        return moment(time).format('YYYY年MM月DD日 HH时');
      }
    },
    projectStyle: data => {
      if (data === '1') {
        return '现场开标';
      } else if (data === '2') {
        return '非现场开标';
      }
    }
  }
};
</script>
<style scoped lang="less">

</style>
